export { default as useSelectorWithArguments } from "./useSelectorWithArguments"
